var map = {
	"./card-conch.png": [
		"4e02",
		7,
		"chunk-2d0cc569"
	],
	"./card-grouper.png": [
		"c512",
		7,
		"chunk-2d216ec9"
	],
	"./card.png": [
		"679c",
		7
	],
	"./designs": [
		"1988",
		3
	],
	"./designs.json": [
		"1988",
		3
	],
	"./logo-round-transparent.png": [
		"eb43",
		7,
		"chunk-2d2300d2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39aa";
module.exports = webpackAsyncContext;